export const ACCENTS = {
  coral: "#FF6F61",
  sunshine: "#FFD166",
  mint: "#06D6A0",
  sky: "#4FC3F7",
  lavender: "#CDB4DB",
  sage: "#84A59D",
  clay: "#D4A373",
};

export const COLOR_OPTIONS = ["coral", "sunshine", "mint", "sky", "lavender", "sage", "clay"];

export function accentHex(c) {
  return ACCENTS[c] || ACCENTS.coral;
}

export const MEAL_TYPES = ["breakfast", "lunch", "dinner", "snack"];

export const MEAL_ICONS = {
  breakfast: "🍳",
  lunch: "🥪",
  dinner: "🍽️",
  snack: "🍎",
};

export const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
export const DAY_NAMES_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
}
